export default "__VITE_ASSET__B0FDk3XC__"